import { Controller } from '@hotwired/stimulus'
import { on, off, emit } from '../lib/events'

export default class extends Controller {
  static targets = ['modal']

  static values = {
    url: String,
    caption: String,
    description: String,
    image: String,
    onConnect: String,
  }

  connect = () => {
    on('openShareProduct', this.share)
  }

  disconnect = () => {
    off('openShareProduct', this.share)
  }

  share = () => {
    if (navigator.share) {
      navigator.share({
        title: this.captionValue,
        text: this.descriptionValue,
        url: this.urlValue,
      })
    }
    else if (this.hasModalTarget) {
      this.showModal()
    }
    else {
      emit('openShareProductModal', { bubbles: true })
    }
  }

  showModal = (show = true) => {
    if (!this.hasModalTarget) return

    const toggle = (show && this.modalTarget.classList.contains('hidden'))
      || (!show && !this.modalTarget.classList.contains('hidden'))
    if (toggle) {
      this.modalTarget.classList.toggle('hidden')
    }
  }

  closeModal = () => {
    this.showModal(false)
  }

  copyLink = async (event) => {
    const button = event.currentTarget

    try {
      await navigator.clipboard.writeText(this.urlValue)

      button.classList.add('copy-button-clicked')
      button.textContent = 'Copied!'

      setTimeout(() => {
        button.classList.remove('copy-button-clicked')
        button.textContent = 'Copy Link'
      }, 1500)
    }
    catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  openWindow = (url, width = 500, height = 500) => {
    const top = (window.screen.height / 2) - (height / 2)
    const left = (window.screen.width / 2) - (width / 2)

    const options = [
      `top=${top}`,
      `left=${left}`,
      'toolbar=0',
      'status=0',
      `width=${width}`,
      `height=${height}`,
    ].join(',')

    window.open(url, '_blank', options)
  }

  url = (url, params = {}) => {
    const composedUrl = new URL(url)

    Object.keys(params).forEach((key) => {
      composedUrl.searchParams.append(key, params[key])
    })

    return composedUrl
  }

  shareFacebook = () => {
    const params = {
      u: this.urlValue,
      picture: this.imageValue,
      title: 'Darkroom',
      caption: this.captionValue,
      description: this.descriptionValue,
    }

    const url = this.url('https://www.facebook.com/sharer.php', params)
    this.openWindow(url)
  }

  sharePinterest = () => {
    const params = {
      url: this.urlValue,
      media: this.imageValue,
      description: this.descriptionValue,
    }

    const url = this.url('https://www.pinterest.com/pin/create/link', params)
    this.openWindow(url)
  }

  shareTwitter = () => {
    const params = {
      text: this.descriptionValue,
      url: this.urlValue,
    }

    const url = this.url('https://twitter.com/intent/tweet', params)
    this.openWindow(url)
  }
}
